// noinspection ES6CheckImport
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { ContentHeader, NoContentBox } from 'components/basic'
import { AccessOrders, AccessEditor, Subscriptions, AvailableServices, Tickets, CPEstatus, LinkStatus, MacAddressTable, LeaseInfo, IgmpSnoopStatus } from 'projects/flow-gui-access/components/2.4'
import { notify } from 'helpers'
import http from 'API/http'

class Access extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      errors: {
        cpeStatus: {
          error: false
        },
        hardware: {
          error: false
        },
        linkStatus: {
          error: false
        },
        igmpsnooping: {
          error: false
        },
        leaseInfo: {
          error: false
        },
        macaddresstable: {
          error: false
        }
      },
      updated: Date.now()
    }
    this.interval = null
  }
  reload () {
    this.getAccess(this.props.match.params.accessid)
  }
  componentDidMount () {
    this.getAccess(this.props.match.params.accessid)
    this.getLeaseInfo(this.props.match.params.accessid)
    this.getMacAddressTable(this.props.match.params.accessid)
    this.getCPEstatus(this.props.match.params.accessid)
    this.getLinkStatus(this.props.match.params.accessid)
    this.getIGMP(this.props.match.params.accessid)
  }
  componentWillUnmount () {
    this.stopAutoReload()
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.match.params.accessid === nextProps.match.params.accessid) return
    this.getAccess(nextProps.match.params.accessid)
    this.getLeaseInfo(nextProps.match.params.accessid)
    this.getMacAddressTable(nextProps.match.params.accessid)
    this.getCPEstatus(nextProps.match.params.accessid)
    this.getLinkStatus(nextProps.match.params.accessid)
    this.getIGMP(nextProps.match.params.accessid)
  }
  async getAccess (accessId) {
    var [err, res] = await http.get('2.4/accesses/' + accessId)
    if (err) return notify.alert('', res.message, 'error')
    this.setState({access: res.data, updated: Date.now()})
    this.autoReload()
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: `${res.data.streetName} ${res.data.streetNumber}`
    })
  }
  async getLeaseInfo (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/leaseinfo')
    err ? this.setState({errors: {...this.state.errors, leaseInfo: {error: true, cause: res.cause}}, updated: Date.now()}) : this.setState({leaseInfo: res.data, updated: Date.now()})
  }
  async getMacAddressTable (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/macaddresstable')
    err ? this.setState({errors: {...this.state.errors, macaddresstable: {error: true, cause: res.cause}}, updated: Date.now()}) : this.setState({macaddresstable: res.data, updated: Date.now()})
  }
  async getCPEstatus (id) {
    var [err, res] = await http.get('2.4/tech/cpe/' + id + '/status')
    err ? this.setState({errors: {...this.state.errors, cpeStatus: {error: true, cause: res.cause}}, updated: Date.now()}) : this.setState({cpeStatus: res.data, updated: Date.now()})
  }
  async getLinkStatus (id) {
    var [hwerr, hardware] = await http.get('2.4/tech/' + id + '/access/hardware')
    var [linkerr, linkStatus] = await http.get('2.4/tech/access/' + id + '/link/status')
    hwerr ? this.setState({errors: {...this.state.errors, hardware: {error: true, cause: hardware.cause}}, updated: Date.now()}) : this.setState({hardware: hardware.data, updated: Date.now()})
    linkerr ? this.setState({errors: {...this.state.errors, linkStatus: {error: true, cause: linkStatus.cause}}, updated: Date.now()}) : this.setState({linkStatus: linkStatus.data, updated: Date.now()})
  }
  async getIGMP (id) {
    var [err, res] = await http.get('2.4/tech/access/' + id + '/link/igmpsnooping')
    err ? this.setState({errors: {...this.state.errors, igmpsnooping: {error: true, cause: res.cause}}, updated: Date.now()}) : this.setState({igmpsnooping: res.data, updated: Date.now()})
  }
  autoReload () {
    this.stopAutoReload()
    this.interval = setTimeout(() => {
      this.getAccess(this.props.match.params.accessid)
    }, 30000)
  }
  stopAutoReload () {
    if (typeof this.interval !== 'undefined') {
      clearTimeout(this.interval)
      delete this.interval
    }
  }
  render () {
    if (!this.state.access) {
      return (
        <div className="content-wrapper flexbox-absolute-center">
          <NoContentBox icon='circle-o-notch fa-spin' text='Loading Access' />
        </div>
      )
    }
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle={`${this.state.access.streetName} ${this.state.access.streetNumber}`} buttons={[ { tip: 'Dashboard', icon: 'fa-home', event: () => (window.location.hash = '/access') } ]} />
        <hr />
        <div className='row'>
          <AccessEditor access={this.state.access} />
          <Subscriptions callback={() => this.reload()} services={this.state.access.active} accessId={this.state.access.accessId} updated={this.state.updated} />
        </div>
        <Tabs selectedTabClassName='flow-tab-active'>
            <TabList className='flow-tabs'>
              <Tab className='flow-tab'><i className='fa fa-home' /> Access</Tab>
              <Tab className='flow-tab'><i className='fa fa-shield' /> CPE Status</Tab>
              <Tab className='flow-tab'><i className='fa fa-server' /> Link Status</Tab>
              <Tab className='flow-tab'><i className='fa fa-globe' /> Client Info</Tab>
            </TabList>
          <TabPanel>
            <div className='row'>
              <AvailableServices callback={() => this.reload()} access={this.state.access} updated={this.state.updated} />
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div className='row'>
                  <AccessOrders callback={() => this.reload()} id={this.state.access.accessId} updated={this.state.updated} />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <Tickets accessId={this.state.access.accessId} />
                </div>
              </div>
            </div>
          </TabPanel>
          <div>
            <TabPanel>
              <div className='row'>
                <CPEstatus reload={() => this.getCPEstatus(this.props.match.params.accessid)} cpeStatus={this.state.cpeStatus} errors={this.state.errors.cpeStatus} updated={this.state.updated} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='row'>
                <LinkStatus reload={() => this.getLinkStatus(this.props.match.params.accessid)} linkStatus={this.state.linkStatus} hardware={this.state.hardware} linkerr={this.state.errors.linkStatus} hwerr={this.state.errors.hardware} updated={this.state.updated} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='row'>
                    <MacAddressTable reload={() => this.getMacAddressTable(this.props.match.params.accessid)} macaddresstable={this.state.macaddresstable} errors={this.state.errors.macaddresstable} updated={this.state.updated} />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row'>
                    <IgmpSnoopStatus reload={() => this.getIGMP(this.props.match.params.accessid)} igmpsnooping={this.state.igmpsnooping} errors={this.state.errors.igmpsnooping} updated={this.state.updated} />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='row'>
                    <LeaseInfo reload={() => this.getLeaseInfo(this.props.match.params.accessid)} leaseInfo={this.state.leaseInfo} errors={this.state.errors.leaseInfo} updated={this.state.updated} />
                  </div>
                </div>
              </div>
            </TabPanel>
          </div>
        </Tabs>
      </div>
    )
  }
}
//eslint-disable-next-line
Access = connect(state => state.siteReducer)(Access)
export default Access



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/access/access.js